import { render } from "./UnderwritingCategoryModal.vue?vue&type=template&id=5b41a035"
import script from "./UnderwritingCategoryModal.vue?vue&type=script&lang=js"
export * from "./UnderwritingCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__